import { render } from "./RatingInput.vue?vue&type=template&id=9ed974a8&scoped=true"
import script from "./RatingInput.vue?vue&type=script&lang=ts"
export * from "./RatingInput.vue?vue&type=script&lang=ts"

import "./RatingInput.vue?vue&type=style&index=0&id=9ed974a8&scoped=true&lang=postcss"
script.render = render
script.__scopeId = "data-v-9ed974a8"
/* custom blocks */
import block0 from "./RatingInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script